import { combineReducers } from 'redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import GraduatesReducer from './GraduatesReducer/GraduatesReducer';
import TeamReducer from './TeamReducer/TeamReducer';
import ProjectsReducer from './ProjectsReducer/ProjectsReducer';

const rootReducer = combineReducers({
  graduates: GraduatesReducer,
  team: TeamReducer,
  projects: ProjectsReducer,
});


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(rootReducer, /* preloadedState, */ composeEnhancers(
  applyMiddleware(thunk)
));